const logService = {
  log(err) {
    if (err.response) {
      return
    }
    logService.logError(err)
  },
  logError(err) {
    const copy = JSON.parse(JSON.stringify(err))
    console.log(copy)
    return copy
  },
  install(Vue) {
    Vue.prototype.$log = this.log
  },
}

export default logService
